import actions from './actions';

const {
	
	FETCH_BILL_BEGIN,
	FETCH_BILL_SUCCESS,
	FETCH_BILL_ERR,

	CONFIRM_BILL_BEGIN,
	CONFIRM_BILL_SUCCESS,
	CONFIRM_BILL_ERR,

} = actions;

const initialStateFilter = {
	data: null,
	loading: false,
	error: null,
};

const billReducer = (state = initialStateFilter, action) => {
	const { type, data, err } = action;
	switch (type) {
		case FETCH_BILL_BEGIN:
			return {
				data: null,
				loading: true,
				error: null,
			};
		case FETCH_BILL_SUCCESS:
			return {
				data: data,
				loading: false,
				error: null,
			};
		case FETCH_BILL_ERR:
			return {
				data: null,
				loading: false,
				error: err,
			};

		case CONFIRM_BILL_BEGIN:
			return {
				...state,
				loading: true,
				error: null,
			};
		case CONFIRM_BILL_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case CONFIRM_BILL_ERR:
			return {
				...state,
				loading: false,
				error: err,
			};

		default:
			return state;
	}
};

export default billReducer;
